export const NEW_STATUS = 'Новый'
export const IN_PROGRESS_STATUS = 'В работе'
export const EXECUTED_STATUS = 'Завершен'
export const CANCEL_STATUS = 'Отменен'
export const DECLINED_STATUS = 'Отказан'
export const NEED_REVISION_STATUS = 'Требуется доработка'

export const POSTPONED_STATUS = 'Отложен'
